export default {"src":"/_next/static/media/appstoreFr.b22c5bb0.svg","height":40,"width":127,"blurWidth":0,"blurHeight":0};